import * as tslib_1 from "tslib";
import { OnChanges, SimpleChanges } from '@angular/core';
import { ScriptLoaderService } from '../../shared/script-loader/script-loader.service';
import { isNullOrUndefined } from '../../util/helpers';
var nextId = 0;
var SkyVectorChartComponent = /** @class */ (function () {
    function SkyVectorChartComponent(_scriptLoader) {
        this._scriptLoader = _scriptLoader;
    }
    SkyVectorChartComponent.prototype._update = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!isNullOrUndefined(this.lat) && !isNullOrUndefined(this.lon))) return [3 /*break*/, 2];
                        nextId++;
                        this.CONTAINER_ID = 'appskyvector' + nextId;
                        return [4 /*yield*/, this._scriptLoader.load(this.sectionalUrl)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    SkyVectorChartComponent.prototype.ngOnChanges = function (changes) {
        if (changes.lat || changes.lon) {
            this._update();
        }
    };
    Object.defineProperty(SkyVectorChartComponent.prototype, "sectionalUrl", {
        get: function () {
            return "https://skyvector.com/perl/ad1?lat=" + this.lat + "&lon=" + this.lon + "&s=2&c=" + this.CONTAINER_ID + "&t=_blank";
        },
        enumerable: true,
        configurable: true
    });
    return SkyVectorChartComponent;
}());
export { SkyVectorChartComponent };
